import { Badge } from "@/components/ui/badge.tsx";
import { Loader2, Sparkles, X } from "lucide-react";

interface SkillUsageTagsProps {
  skillUses: string[];
  onRemove: (value: string) => void;
  onAddMore: () => Promise<void>;
  disabled?: boolean;
  isLoading?: boolean;
}

export function SkillUsageTags({
  skillUses,
  onRemove,
  onAddMore,
  disabled = false,
  isLoading = false,
}: SkillUsageTagsProps) {
  return (
    <div className="flex flex-wrap gap-1">
      {skillUses.map((usage) => (
        <button
          type="button"
          key={usage}
          onClick={() => onRemove(usage)}
          className="group"
          aria-label={`Remove ${usage}`}
        >
          <Badge variant="secondary" className="text-xs cursor-pointer">
            <span>{usage}</span>
            <X className="ml-1 h-3 w-3 opacity-60 group-hover:opacity-100" />
          </Badge>
        </button>
      ))}

      <button
        type="button"
        onClick={() => void onAddMore()}
        disabled={disabled || isLoading}
        className="disabled:cursor-not-allowed disabled:opacity-60"
        aria-label="Add more skill uses"
      >
        <Badge variant="outline" className="text-xs cursor-pointer">
          {isLoading
            ? <Loader2 className="h-3 w-3 animate-spin" />
            : <Sparkles className="h-3 w-3" />}
        </Badge>
      </button>
    </div>
  );
}
